import { SortParams } from '../../../typings/grid';
import { Product } from '../../../typings/products';

export const ADD_CREATED_INTERNAL_PRODUCT = 'ADD_CREATED_INTERNAL_PRODUCT';
export type ADD_CREATED_INTERNAL_PRODUCT = typeof ADD_CREATED_INTERNAL_PRODUCT;

export interface AddCreatedInternalProduct {
    type: ADD_CREATED_INTERNAL_PRODUCT;
    product: Product;
    sortParams?: SortParams;
}

export function addCreatedInternalProductAction(product: Product, sortParams?: SortParams): AddCreatedInternalProduct {
    return {
        type: ADD_CREATED_INTERNAL_PRODUCT,
        product,
        sortParams
    };
}
